module.exports = __webpack_public_path__ + "img/14.4e4bf231.webp";